export const environment = {
    apiBaseUrl: 'https://dev.gw3.global-lab.eu/api/v1',
    fileHashAlgorithm: 'SHA256'
};
